import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=8ee1f94e"
import script from "./task-list.vue?vue&type=script&lang=js"
export * from "./task-list.vue?vue&type=script&lang=js"
import style0 from "./task-list.vue?vue&type=style&index=0&id=8ee1f94e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports